import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  addHtmlRootEventListener,
  CURRENCY_EURO,
  getHtmlElement,
  hasValidVoucher,
  isPresent,
  parseAmount,
  removeHtmlChildren,
  renderWebComponent
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import styles from '../../styles/modal.css'
import { EventBusComponent } from "../EventBusComponent";
import I18n from "i18n-js";

export class SubmissionListPricingSummaryModalComponent extends HTMLElement {

  eventBus = null;
  modal = null;

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
    this.render();
  }

  connectedCallback() {
    const modal = getHtmlElement(this.shadowRoot, 'pricingModal');
    this.eventBus.subscribe('render-submission-list_pricing-summary-modal', (submissionList) => {
      setTimeout(() => this.setModalContent(submissionList), 1);
    });

    addHtmlElementEventListener(this.shadowRoot, 'closeButton1', 'click', () => modal.classList.remove("show"));
    addHtmlRootEventListener(window, 'keydown', (e) => e.key === 'Escape' ? modal.classList.remove("show") : {});

    // window.top.document.addEventListener("click", function(e) {
    //   if (!modal.contains(e.target)) {
    //     modal.classList.remove("show");
    //   }
    // });
  }


  setModalContent(submissionList) {
    const parsePriceKey = (key) => {
      return submissionList[`${submissionList.priceType}${key}`];
    }

    const modalBody = getHtmlElement(this.shadowRoot, 'body');
    removeHtmlChildren(modalBody);

    // Calcola il prezzo prima dello sconto speciale
    const serviceAmountBeforeDiscount = parsePriceKey('base_service_amount_vat_excluded');

    const template = document.createElement('template')
    template.innerHTML = `
      <p class="mb-1"><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.amountsVatExcluded').toUpperCase()}</b></p>

      <div class="d-flex justify-content-between align-items-end pb-1">
        <div class="pr-3">${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.gradingServices').toUpperCase()}</div>
        <div>${parseAmount(serviceAmountBeforeDiscount, 2, true)}${CURRENCY_EURO}</div>
      </div>

      <div class="d-flex justify-content-between align-items-end pb-1">
        <div class="pr-3">${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.gradingServicesDiscount').toUpperCase()}</div>
        <div>
          ${
            hasValidVoucher(submissionList) ?
              '-' + (
                  (submissionList.voucher.amount > 0 ?
                    parseAmount(submissionList.voucher.amount, 2) + CURRENCY_EURO
                  :
                    (submissionList.voucher.percentage || 0) + '%') + CURRENCY_EURO)
              :
            '--'
          }
        </div>
      </div>
      
      ${
        isPresent(submissionList.grader_company.home_pick_up_method) || isPresent(submissionList.grader_company.return_delivery_method) ?
          `<div class="d-flex justify-content-between align-items-end pb-1">
            <div class="pr-3">${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shipping').toUpperCase()}</div>
            <div>${parseAmount(parsePriceKey('global_shipping_cost_vat_excluded'), 2, true)}${CURRENCY_EURO}</div>
          </div>`
        :
          ``
      }
      
      ${
        submissionList.grader_company.has_insurance_options ?
          `<div class="d-flex justify-content-between align-items-end pb-2">
            <div class="pr-3">${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shippingInsurance').toUpperCase()}</div>
            <div>${parseAmount(parsePriceKey('insurance_cost_vat_excluded'), 2, true)}${CURRENCY_EURO}</div>
          </div>`
        :
          ``
      }
      
      <div class="d-flex justify-content-between align-items-end pt-2 pb-1 border-top-solid">
        <div class="pr-3"><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.subtotalVatExcluded').toUpperCase()}</b></div>
        <div><b>${parseAmount(parsePriceKey('all_services_amount_vat_excluded'), 2, true)}${CURRENCY_EURO}</b></div>
      </div>
      
      <div class="d-flex justify-content-between align-items-end pb-1">
        <div class="pr-3">${I18n.t('js.editSubmissionListPage.webComponent.draft.vatRate').toUpperCase()}</div>
        <div>${parsePriceKey('vat_rate')}%</div>
      </div>
      
      <div class="d-flex justify-content-between align-items-end pb-2">
        <div class="pr-3">${I18n.t('js.editSubmissionListPage.webComponent.draft.vatAmount').toUpperCase()}</div>
        <div>${parseAmount(parsePriceKey('vat_amount'), 2, true)}${CURRENCY_EURO}</div>
      </div>
      
      <div class="d-flex justify-content-between align-items-end pt-2 pb-1 border-top-solid">
        <div class="pr-3"><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.subtotalVatIncluded').toUpperCase()}</b></div>
        <div><b>${parseAmount(parsePriceKey('all_services_amount'), 2, true)}${CURRENCY_EURO}</b></div>
      </div>
      
      <div class="d-flex justify-content-between align-items-end pb-2">
        <div class="pr-3">${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.piggyBankUsed').toUpperCase()}</div>
        <div>-${parseAmount(submissionList.user_credit, 2, true)}${CURRENCY_EURO}</div>
      </div>
      
      <div class="d-flex justify-content-between align-items-end pt-2 mb-0 border-top-solid">
        <div class="pr-3"><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.amountVatIncluded').toUpperCase()}</b></div>
        <div><b>${parseAmount(parsePriceKey('amount'), 2, true)}${CURRENCY_EURO}</b></div>
      </div>
    `
    modalBody.appendChild(template.content.cloneNode(true));

    addHtmlElementClass(this.shadowRoot, 'pricingModal', 'show');
  }


  render() {
    const html = `      
      <div class="modal fade" id="pricingModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content br-8px">
            <div class="w-100 m-0 bg-aig-gradient p-2px br-8px">
              <div class="w-100 p-0 m-0 bg-white br-8px">
                <div class="modal-header border-bottom-none-imp mb-0 pb-0 pt-1" id="header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeButton1">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body pt-1" id="body"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, styles]);
  }
}

window.customElements.define("submission-lsit-pricing-summary-modal-component", SubmissionListPricingSummaryModalComponent);